import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { InternalGrid, SkeletonItem } from '@paygreen/paygreen-ui';
import { H1Title, HideAndCopy } from '../../../components';

const AdminUserTitle = ({ t, isLoading, organisationName, accountId }) => {
    const baseHost = window.location.origin;

    return (
        <InternalGrid
            hasStaticWidth={false}
            displayType="grid"
            gridTemplateColumns="1fr auto"
            gridGap="md"
            alignItems={isLoading ? 'flex-start' : 'center'}
            childrenMarginBottom="lg"
        >
            <SkeletonItem
                blockWidth="md"
                blockHeight="xs"
                colorWab="grey10"
                radiusSize="none"
                isLoading={isLoading}
            >
                {/* the no data found alternative guarantees skeleton title length while loading data */}
                <H1Title
                    marginBottom="none"
                    title={organisationName || t('user.noDataFound')}
                />
            </SkeletonItem>

            <HideAndCopy
                title={t('admin.user.copyUrlTitle')}
                hasHiddenText={false}
                icon="LinkIcon"
                iconSize="sm"
                text={`${baseHost}/admin/users/${accountId}`}
            />
        </InternalGrid>
    );
};

AdminUserTitle.propTypes = {
    isLoading: PropTypes.bool,
    organisationName: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    button: PropTypes.element,
};

AdminUserTitle.defaultProps = {
    isLoading: false,
    organisationName: '',
};

export default withTranslation('common')(AdminUserTitle);
